import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import UserState from "./context/users/UserState";
import "./css/main.css";
import BlogState from "./context/blogs/BlogState";
import 'react-toastify/dist/ReactToastify.css';
import UiState from "./context/ui/uiState";


ReactDOM.render(
  <>
    <BrowserRouter basename="/blogpoint">
    <UiState>
    <BlogState>
      <UserState>
        <App />
      </UserState>
      </BlogState>
      </UiState>
    </BrowserRouter>
  </>,
  document.getElementById("root")
);
